var render, staticRenderFns
import script from "./NetRevenueTrends.vue?vue&type=script&lang=js&"
export * from "./NetRevenueTrends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf387e9a')) {
      api.createRecord('cf387e9a', component.options)
    } else {
      api.reload('cf387e9a', component.options)
    }
    
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/trending-charts/NetRevenueTrends.vue"
export default component.exports